import styled from "styled-components";

const SideBarStyled = styled.div`
    position: fixed;
    height: 100vh;
    min-width:124px;
    z-index:200;
`

export default SideBarStyled